export default "__VITE_ASSET__Cwq4Y_sh__"